import { useContext } from 'react';
import { useSelector } from 'react-redux';
import CheckoutContext from '../lib/CheckoutContext';
import { cartContainsAnyFreeTrialBundle } from '../lib/cart';
import * as types from '../types';
import useHardwareFirstCartUnits from './useHardwareFirstCartUnits';
import useHardwareFirstFreeTrial from './useHardwareFirstFreeTrial';

/**
 * Whether klarna bnpl may be offered for the checkout cart. Not on a hardware-first cart: recurly can
 * only complete a klarna redirect when the purchase carries a subscription, and a hardware-first
 * purchase is line items only (the membership is charged at activation). Not on a cart holding a
 * free trial in hardware-first checkout either, whose device is charged later off the stored card. Control carts are unaffected.
 * Must be called inside a CheckoutContextProvider.
 */
export default function useHardwareFirstBnplOffered(): boolean {
  const units = useHardwareFirstCartUnits();
  const hardwareFirstTrial = useHardwareFirstFreeTrial();
  const { cart } = useContext(CheckoutContext);
  const products = useSelector((state: types.AppState) => state.config.products);
  return units === 0 && !(hardwareFirstTrial && cartContainsAnyFreeTrialBundle(cart, products));
}
